import type { StudentAssignmentCubit } from '@breakoutlearning/firebase-repository/cubits/StudentAssignmentCubit'
import { Spinner } from 'components/Spinner'
import { Dialog } from 'components/dialogs/Dialog'
import { DialogCloseButton } from 'components/dialogs/DialogCloseButton'
import { observer } from 'mobx-react-lite'
import { t } from 'i18next'
import { CourseMaterialListItem } from 'components/slide-deck-material-components/CourseMaterialListItem'
import { useId } from 'react'

const MaterialsModalBody = observer(function MaterialsModalBody({
  cubit,
  headingId,
}: {
  cubit: StudentAssignmentCubit
  headingId: string
}) {
  const {
    id,
    data: { slideDeckName },
  } = cubit.slideDeck

  return (
    <div className="mx-auto flex h-full flex-col !overflow-hidden">
      <h1 id={headingId} className="mb-2 text-headline-large">
        {t('student_assignment.course_materials')}
      </h1>
      <p className="mb-5 text-body-large text-on-surface-var">
        {t('student_assignment.course_materials_info')}
      </p>
      {cubit.materials.isLoading ? (
        <div className="my-10 flex flex-row items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <div className="h-full flex-grow overflow-auto">
          {cubit.availableStudentMaterials.map((material) => (
            <CourseMaterialListItem
              slideDeckVersion={cubit.slideDeck.data.slideDeckVersion}
              key={material.id}
              className="mb-2 flex h-[62px] flex-row items-center justify-between gap-3 rounded-2xl bg-light-grey p-5"
              slideDeckName={slideDeckName}
              slideDeckId={id}
              material={material}
              onViewTap={() => {
                cubit.logEvent('student_view_course_material', {
                  material_id: material.id,
                })
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
})

export function MaterialsModal({ cubit }: { cubit: StudentAssignmentCubit }) {
  const headingId = useId()
  return (
    <Dialog size="md" testId="materials-modal" aria-labelledby={headingId}>
      <DialogCloseButton />
      <MaterialsModalBody cubit={cubit} headingId={headingId} />
    </Dialog>
  )
}
